import { resolveChartDimensionField } from './chartIntervals'
import { collapsesChartIndex, isTimeGroupbyField } from './chartUtils'
import { isGroupbyAvailable } from './collectionGroupby'
import { definitionToMetric, getMetricDefinition } from './collectionMetrics'
import { normalizeMetrics } from './constants'

export function resolveChartQueryGroupby(chart, config) {
  const fields = []

  if (!collapsesChartIndex(chart?.dataType)) {
    const dimension = resolveChartDimensionField(chart, config)
    if (dimension) fields.push(dimension)
  }

  const { seriesBy } = chart || {}
  if (seriesBy && !fields.includes(seriesBy) && isGroupbyAvailable(config?.collection, seriesBy)) {
    fields.push(seriesBy)
  }

  return fields
}

function resolveChartQueryMetrics(chart, collection) {
  const keys = [...new Set((chart?.metricKeys || []).filter(Boolean))]

  const metrics = keys
    .map(key => getMetricDefinition(collection, key))
    .filter(Boolean)
    .map(definitionToMetric)

  return normalizeMetrics(metrics)
}

function resolveChartQuerySortby(chart, groupby) {
  const [dimension] = groupby
  if (dimension && isTimeGroupbyField(dimension)) return [`${dimension} asc`]

  const primary = chart?.breakdown || chart?.metricKeys?.[0]

  return primary ? [`${primary} desc`] : []
}

export function buildChartQuery(chart, config) {
  const groupby = resolveChartQueryGroupby(chart, config)
  if (!groupby.length) return null

  const metrics = resolveChartQueryMetrics(chart, config?.collection)
  if (!metrics.length) return null

  return {
    id: chart.id,
    groupby,
    metrics,
    sortby: resolveChartQuerySortby(chart, groupby),
  }
}
